import * as pay from "./pay";
import * as billing from "./billing";

export const nice = {
    ...pay,
    ...billing
};
